import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NavigationService } from '../../../../services/navigation/navigation.service';

export interface AccountNotExistedDialogComponentData {
  redirectLink?: string;
  email?: string;
  phoneNr?: string;
}

@Component({
  selector: 'app-account-not-existed-dialog',
  templateUrl: './account-not-existed-dialog.component.html',
  styleUrls: ['./account-not-existed-dialog.component.scss'],
})
export class AccountNotExistedDialogComponent {
  public email: string;
  public phoneNr: string;
  private redirectLink: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: AccountNotExistedDialogComponentData,
    private dialogRef: MatDialogRef<AccountNotExistedDialogComponent>,
    private navigationService: NavigationService
  ) {
    this.redirectLink = this.data?.redirectLink;
    this.email = this.data?.email;
    this.phoneNr = this.data?.phoneNr;
  }

  public async navigateToRegister() {
    await this.navigationService.navigateToRegister(
      this.redirectLink,
      this.email,
      this.phoneNr
    );
    this.closeDialog();
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
